import { useMemo } from 'react'

import {
  useFilters, useModals, useNumericParams, useSetState,
} from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditPortalOptionModal from '@modals/CreateOrEditPortalOptionModal'
import CreateOrEditPortalOptionValueModal from '@modals/CreateOrEditPortalOptionValueModal'

import { PortalOptionModel } from '@models/portalOption'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditPortalOptionModal: false,
  showCreateOrEditPortalOptionValueModal: false,
}

const callbacks = (
  component: keyof typeof componentCallbacks,
  setState: (payload: Partial<typeof defaultState>) => void,
) => {
  const componentCallbacks = {
    CreateOrEditPortalOptionModal: {
      closeModal: () => setState({ showCreateOrEditPortalOptionModal: false }),
      createPortalOption: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updatePortalOption: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    CreateOrEditPortalOptionValueModal: {
      closeModal: () => setState({ showCreateOrEditPortalOptionValueModal: false }),
      createPortalOptionValue: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updatePortalOptionValue: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const Details = () => {
  const { portalId } = useNumericParams()

  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditPortalOptionModal, showCreateOrEditPortalOptionValueModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      deletePortalOptionValue: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      showCreateOrEditPortalOptionModal: (payload: { entity: PortalOptionModel }) => {
        setModalData('CreateOrEditPortalOptionModal', payload)
        setState({ showCreateOrEditPortalOptionModal: true })
      },
      showCreateOrEditPortalOptionValueModal: (payload: { entity: PortalOptionModel }) => {
        setModalData('CreateOrEditPortalOptionValueModal', payload)
        setState({ showCreateOrEditPortalOptionValueModal: true })
      },
      updatePortal: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent portalId={portalId} />

        <CreateOrEditPortalOptionModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateOrEditPortalOptionModal', setState)}
          showModal={showCreateOrEditPortalOptionModal}
        />

        <CreateOrEditPortalOptionValueModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateOrEditPortalOptionValueModal', setState)}
          showModal={showCreateOrEditPortalOptionValueModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Details
